import { render, staticRenderFns } from "./AutoIdWidget.vue?vue&type=template&id=7a27c424"
import script from "./AutoIdWidget.vue?vue&type=script&lang=js"
export * from "./AutoIdWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports